import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'term',
  standalone: true,
})
export class TermPipe implements PipeTransform {
  transform(termInMonths: number | null, format: 'short' | 'long' = 'short'): string {
    if (termInMonths == null) return '-';

    const years = Math.floor(termInMonths / 12);
    const months = termInMonths % 12;

    if (format === 'long') {
      const yearLabel = years === 1 ? 'year' : 'years';
      const monthLabel = months === 1 ? 'month' : 'months';

      if (months && years) return `${years} ${yearLabel} ${months} ${monthLabel}`;
      if (months) return `${months} ${monthLabel}`;
      return `${years} ${yearLabel}`;
    }

    if (months && years) return `${years}y ${months}m`;
    if (months) return `${months}m`;
    return `${years}y`;
  }
}
